import { connect } from "react-redux";
import { Link } from "react-router-dom";
import React from "react";

import { Card } from "../../component-library/Card";
import { clearAuthChallenge } from "../../redux/actions/auth";
import { Footer } from "../../component-library/Footer";
import { Header } from "../../component-library/Header";

const FormWrapper = (props) => {
  const backLinkDisplay = props.showBackLink ? "block" : "none";

  const clearAuthData = () => {
    localStorage.removeItem("idpOptions");
    localStorage.removeItem("idpLoginUrl");
    localStorage.removeItem("ssoInProgress");
    localStorage.removeItem("idpLogoutUrl");

    if (props.challengeName) {
      props.clearAuthChallenge();
    }
  };

  return (
    <>
      <Header />
      <div className="apti-Backlink-Wrapper">
        <Link
          onClick={() => clearAuthData()}
          style={{
            color: "#0CD0A7",
            display: backLinkDisplay,
            position: "absolute",
          }}
          to="/auth/sign-in"
        >
          <b>Back</b>
        </Link>
        <Card className="no-border apti-Login-Card auto-height">{props.children}</Card>
      </div>
      <Footer contentcolor="grey" />
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    challengeName: state.auth.challengeName,
  };
};

export default connect(mapStateToProps, { clearAuthChallenge })(FormWrapper);
